const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    "&  .groupHeaderChildren": {
      borderLeft: `1px solid ${theme.AppBGColor} !important`,
    },
    "& .ag-theme-material .ag-header-cell": {
      borderColor: theme.gridGroupHeaderBorderColor,
    },
    "& div[role='presentation'][col-id='totalPickups']": {
      borderRight: `1px solid ${theme.AppBGColor} !important`,
    },
    "& div[col-id='5_0']": {
      borderRight: `1px solid ${theme.AppBGColor} !important`,
    },
    "& .groupHeaderParent": {
      borderLeft: `1px solid ${theme.AppBGColor} !important`,
      "& .ag-header-group-cell-label": {
        justifyContent: "center",
      },
    },
    "& .dispatch-message": {
      fontSize: "24px",
      paddingTop: "2px",
      cursor: "pointer",
    },
    "& .dispatch-new-message": {
      fill: `${theme.HeaderSelectedText}`,
    },
    "& .dispatch-new-message-number": {
      color: `${theme.HeaderSelectedText}`,
    },
    "& .dispaly-message": {
      display: "flex",
      justifyContent: "flex-end",
      width: 8
    },
    "& .driver-status-container": {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: 'center'
    },
    "& .driver-status-icon-container": {
      width: "10%",
    },
    "& .driver-status-icon": {
      fill: `${theme.HeaderSelectedText}`,
    },
    "& .driver-status-stopType": {
      border: `1px solid ${theme.HeaderSelectedText}`,
      width: 16,
      height: 16,
      padding: 2,
      display: 'flex',
      alignItems: 'center',
      borderRadius: 3
    },
    "& .driver-status-stopType-delivery": {
      borderRadius: "50%",
    },
    "& .driver-status-label": {
      width: "90%",
      paddingLeft: "5px",
    },
    "& .dispatch-time":{
      display:'flex',
      alignItems:'center'
    },
    "& .dispatch-time-value-error":{
     color: theme.ErrorMessageColor
    },
    "& .dispatch-time-icon-container":{
      color: theme.ErrorMessageColor,
      paddingLeft:5
    }
  },
});
export default styles;